/* eslint-disable i18next/no-literal-string -- tab identifier values */
export const DOCUMENT_EXTRACTION_TAB = 'document';
export const CREATE_MANUALLY_TAB = 'manual';
/* eslint-enable i18next/no-literal-string */
